<div class="flex h-[50px] w-[50px] items-center justify-center">
  <span class="loader" [style.font-size.px]="size" [style.top]="'-10px'"></span>
</div>
